import React from "react"
import classnames from "classnames"
import { ColumnGroup, H3, Content } from "AtomicComponents"
import { Image, VideoPlayer } from "AtomicContainers"
import componentParser from "AtomicUtils/componentParser"
import styles from "./FiftyFiftyBlock.less"

class FiftyFiftyBlock extends React.PureComponent {
  _renderImage = () => {
    const { imageUrl, size = "disable", overlay = false } = this.props

    return (
      <div
        className={classnames({
          [styles.Media]: true
        })}>
        <div
          className={classnames({
            [styles.MediaImage]: true,
            [styles.MediaImageLarge]: size === "large",
            [styles.MediaImageMedium]: size === "medium",
            [styles.MediaImageSmall]: size === "small",
            [styles.MediaImageInitial]: overlay
          })}>
          <Image src={imageUrl} />
        </div>
      </div>
    )
  }

  _renderVideo = () => {
    const { imageUrl, videoUrl } = this.props
    return (
      <div
        className={classnames({
          [styles.Media]: true
        })}>
        <VideoPlayer src={videoUrl} poster={imageUrl} />
      </div>
    )
  }

  _renderContent = () => {
    const { heading, blurb, textAlign, headingUppercase = true, components = [], children } = this.props
    return (
      <div
        className={classnames({
          [styles.Content]: true,
          [styles.ContentCenter]: textAlign === "center",
          [styles.ContentRight]: textAlign === "right",
          [styles.ContentHeading]: !headingUppercase
        })}>
        {heading && <H3>{heading}</H3>}
        {blurb && <Content xmlString={blurb} textAlign={textAlign} />}
        <br />
        {componentParser(components) || children}
      </div>
    )
  }

  render() {
    const {
      imagePosition = "left",
      imagePositionMobile = false, // if true means image has to be top on mobile
      ratio = 60,
      videoUrl,
      backgroundColor,
      size
    } = this.props

    return (
      <ColumnGroup
        sizes={[Number(ratio), 100 - Number(ratio)]}
        size={size}
        backgroundColor={backgroundColor}
        reverseOnDesktop={imagePosition === "right"}
        reverseOnMobile={!imagePositionMobile}
      >
        <div
          className={classnames({
            [styles.ColumnParent]: true
          })}
        >
          {!videoUrl && this._renderImage()}
          {videoUrl && this._renderVideo()}
        </div>
        {this._renderContent()}
      </ColumnGroup>
    )
  }
}

export default FiftyFiftyBlock



// WEBPACK FOOTER //
// ./src/AtomicContainers/FiftyFiftyBlock/FiftyFiftyBlock.jsx